export default "__VITE_ASSET__hfNCHef5__"